import { validateCallback } from "../validateCallback";
import { missingNativeBuild } from "../nativeError";
var Audio = Object.freeze({
  getRecordingPermissionStatus: function getRecordingPermissionStatus() {
    return Promise.resolve("denied");
  },
  requestRecordingPermission: function requestRecordingPermission() {
    return Promise.resolve("denied");
  },
  play: function play(_uri) {
    return Promise.reject(missingNativeBuild("Audio.play"));
  },
  getPlaybackStatus: function getPlaybackStatus() {
    return Promise.resolve({
      state: "idle",
      positionMs: 0
    });
  },
  pause: function pause() {
    return Promise.resolve({
      state: "idle",
      positionMs: 0
    });
  },
  resume: function resume() {
    return Promise.resolve({
      state: "idle",
      positionMs: 0
    });
  },
  seek: function seek(_positionMs) {
    return Promise.resolve({
      state: "idle",
      positionMs: 0
    });
  },
  stop: function stop() {
    return Promise.resolve();
  },
  startRecording: function startRecording() {
    return Promise.reject(missingNativeBuild("Audio.startRecording"));
  },
  getRecordingStatus: function getRecordingStatus() {
    return Promise.resolve({
      state: "idle",
      durationMs: 0
    });
  },
  pauseRecording: function pauseRecording() {
    return Promise.resolve({
      state: "idle",
      durationMs: 0
    });
  },
  resumeRecording: function resumeRecording() {
    return Promise.resolve({
      state: "idle",
      durationMs: 0
    });
  },
  stopRecording: function stopRecording() {
    return Promise.reject(missingNativeBuild("Audio.stopRecording"));
  },
  watchInterruptions: function watchInterruptions(onEvent) {
    validateCallback(onEvent, "Audio.watchInterruptions: onEvent must be a function");
    return function() {
    };
  },
  setNowPlayingInfo: function setNowPlayingInfo(_info) {
    return Promise.resolve();
  },
  clearNowPlayingInfo: function clearNowPlayingInfo() {
    return Promise.resolve();
  },
  watchRemoteCommands: function watchRemoteCommands(onEvent) {
    validateCallback(onEvent, "Audio.watchRemoteCommands: onEvent must be a function");
    return function() {
    };
  }
});
export {
  Audio
};
//# sourceMappingURL=unavailable.js.map
